<script lang="ts">import { cfgHasSports, cfgToThemeCdnPath, FeatureSet, ReleaseStage, stateFeatureSet, wantAtLeastReleaseStage } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { loggedIn, toSiteUrl } from "@infinitro/global";
import TopCard from "./top-card.svelte";
</script>

<a href={cfgHasSports() ? toSiteUrl('/sports/', $loggedIn) : 'javascript:void(0)'}>
	<div class="top-card-container">
		<TopCard
			backgroundImage={cfgToThemeCdnPath('/top-section/small-bottom-left.png')}
			height="100%"
			width="100%"
			backgroundImagePositionX="center"
		/>
		<div class="content-top-card">
			<div class="content-wrapper">
				<div class="card-title">
					<h2 class="card-section-title">
						<span>{$t(Verbiage.sports).toUpperCase()}</span>
					</h2>
				</div>
				<div class="description-container">
					<p class="card-section-body">
						{$t(Verbiage.sports_subtitle)}
					</p>
				</div>
			</div>
		</div>
	</div>
</a>

<style>
	a {
		height: 100%;
		width: 100%
}

	@media (min-width: 1280px) {
		a {
				width: 43%
		}
	}

	.content-top-card {
		position: absolute;
		z-index: 40;
		display: flex;
		height: 100%;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		padding: 1rem
}

	.content-wrapper {
		display: flex;
		height: 100%;
		width: 100%;
		flex-direction: column;
		justify-content: space-between
}

	@media (min-width: 1280px) {
		.content-top-card {
				align-items: center;
				justify-content: space-between;
				padding: 0.75rem
		}
	}

	@media (min-width: 1440px) {
		.content-top-card {
				padding: 1.25rem
		}
	}

	.top-card-container {
		position: relative;
		display: flex;
		height: 100%;
		width: 100%;
		cursor: pointer;
		align-items: center;
		justify-content: space-between
}

	@media (min-width: 1280px) {
		.top-card-container img {
				top: -30px;
				height: 140%
		}
	}

	.description-container {
		width: 100%
}

	@media (min-width: 1280px) {
		.description-container {
				width: 100%
		}
	}

	@media (min-width: 1440px) {
		.description-container {
				width: 80%
		}
	}

	@media (min-width: 640px) {
		.hide-tablet {
				display: none
		}
	}

	@media (min-width: 1280px) {
		.hide-tablet {
				display: flex
		}
	}

	@media (min-width: 640px) {
		.hide-mobile {
				display: flex
		}
	}

	.card-title {
		display: flex;
		justify-content: flex-start
}

	@media (min-width: 1280px) {
		.card-title {
				justify-content: flex-start
		}
	}

	.card-section-title {
		font-size: 14px;
		font-weight: 700;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-alternative-2)
}

	@media (min-width: 640px) {
		.card-section-title {
				font-size: 24px
		}
	}

	@media (min-width: 1280px) {
		.card-section-title {
				font-size: 18px;
			font-size: clamp(8px, 1.1cqi, 18px) !important
		}
	}

	.card-section-body {
		max-width: 60%;
		font-size: 9px;
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family: var(--font-alternative-2);
		text-align: start !important;
		text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5)
}

	@media (min-width: 640px) {
		.card-section-body {
				font-size: 12px;
			font-size: clamp(8px, 0.8cqi, 12px) !important
		}
	}

	@media (min-width: 1600px) {
		.card-section-body {
				font-size: 14px
		}
	}
</style>
